/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Buffer } from 'buffer';

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  userId: ZodTypes.Id,
});

export const UserThumbnailByIdGet = {
  id: 'user.thumbnail-by-id.get',
  tag: 'User',
  summary: 'Get users thumbnail by id',
  description: 'Get users thumbnail by id',
  method: 'get',
  route: (params: z.infer<typeof Params>) => `/user/${params.userId}/thumbnail`,
  flags: { isAuthorized: true },
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.instanceof(Buffer),
        },
      },
    },
  },
} as const satisfies Endpoint;
